module.exports = __webpack_public_path__ + "static/media/from-to.3b89cb48.svg";